import PropTypes from "prop-types";

import Box from "@mui/material/Box";

import { useResponsive } from "../../hooks/use-responsive";

import { NAV, HEADER } from "./config-layout";
import { useTheme } from "@mui/material";

// ----------------------------------------------------------------------

const SPACING = 8;

export default function Main({ children, sx, ...other }) {
  const lgUp = useResponsive("up", "lg");
  const smUp = useResponsive("up", "sm");

  const theme = useTheme();

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        minHeight: 1,
        maxHeight: "100dvh",
        display: "flex",
        width: 1,
        flexDirection: "column",
        overflow: "hidden",
        position: "relative",
        borderTopLeftRadius: theme.shape.borderRadius,
        borderBottomLeftRadius: theme.shape.borderRadius,
        overflowX: "hidden",
        ...(smUp && { pb: `${NAV.MOBILE}px` }),
        ...(lgUp && {
          pb: 0,
          // px: 2,
          // pt: `${HEADER.H_DESKTOP}px`,
          width: `calc(100vw - ${NAV.WIDTH}px)`,
        }),
        ...sx,
      }}
      {...other}
    >
      {children}
    </Box>
  );
}

Main.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object,
};
